import React, { useState } from 'react';

import { useIntl } from 'react-intl';

import { IconButton } from '@atlaskit/button/new';
import { cssMap } from '@atlaskit/css';
import ChevronDownIcon from '@atlaskit/icon/core/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/core/chevron-up';
import MenuGroup from '@atlaskit/menu/menu-group';
import { Inline, Stack, Text } from '@atlaskit/primitives/compiled';

import { AppsGroupItem } from './apps-group-item';
import { messages } from './messages';
import type { AppsGroupProps } from './types';

const styles = cssMap({
	container: {
		width: '100%',
	},
});

export const AppsGroup = (props: AppsGroupProps): React.JSX.Element | null => {
	const { title, items, onToggleSelect, isCustomizing = false } = props;
	const [isCollapsed, setIsCollapsed] = useState(false);
	const intl = useIntl();

	if (!items.length) {
		return null;
	}

	return (
		<Stack space="space.050" xcss={styles.container}>
			<Inline alignBlock="center" space="space.050">
				<IconButton
					label={
						isCollapsed
							? intl.formatMessage(messages.expandButtonLabel)
							: intl.formatMessage(messages.collapseButtonLabel)
					}
					icon={isCollapsed ? ChevronUpIcon : ChevronDownIcon}
					onClick={() => setIsCollapsed(!isCollapsed)}
					appearance="subtle"
					spacing="compact"
				/>
				<Text>{title}</Text>
			</Inline>
			{!isCollapsed && (
				<MenuGroup spacing="cozy">
					{items.map((item, index) => (
						<AppsGroupItem
							key={index}
							{...item}
							isCustomizing={isCustomizing}
							onToggleSelect={onToggleSelect}
						/>
					))}
				</MenuGroup>
			)}
		</Stack>
	);
};
